<template>
  <nav class="api-anchors">
    <button type="button" class="api-anchors__header" @click="toggleIsListOpen">
      <h3>Навигация по статье</h3>
      <SvgIcon v-show="isMobile" :icon="isListOpen ? 'chevron-up' : 'chevron-down'" />
    </button>
    <ul v-if="!!$route.meta.nav?.length" class="api-anchors__list" :class="[{ open: isListOpen }]">
      <li v-for="nav of $route.meta.nav" :key="nav.to">
        <a
          :href="nav.to"
          class="api-anchors__link"
          :class="{ active: activeAnchor === nav.to }"
          @click.prevent="goToAnchor(nav.to)"
        >
          {{ nav.title }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" src="./ApiDocsAnchors.ts"></script>

<style scoped lang="scss" src="./ApiDocsAnchors.scss"></style>
